document.addEventListener('DOMContentLoaded', function() {
  const menuDetailsCustom = document.getElementById('Details-menu-drawer-container-custom');
  const menuToggleCustom = document.querySelector('#Details-menu-drawer-container-custom .open__header__icon');
  const closeButtonCustom = document.querySelector('.nav-close-button');
  const headerSubdrawer = document.querySelector('.header-subdrawer');
  const menuDrawer = document.getElementById('menu-drawer');
  const subdrawerUl = headerSubdrawer.querySelector('.menu-drawer__menu');
  const mainBody = document.querySelector('body');
  const drawerImage = headerSubdrawer.querySelector('.drawer__image img');
  const drawerImageLink = headerSubdrawer.querySelector('.drawer__image a');

  
  let currentOpenMenuItem = null;

  // Currency drawer functionality
  const currencyDrawer = document.getElementById('drawer');
  const closeDrawerBtn = document.getElementById('closeDrawerBtn');
  
  // Show/hide subdrawer functions
  function showSubdrawer() {
    headerSubdrawer.classList.remove('hidden');
    headerSubdrawer.classList.add('active');
    menuDrawer.classList.add('expanded');
  }

  function hideSubdrawer() {
    headerSubdrawer.classList.add('hidden');
    headerSubdrawer.classList.remove('active');
    menuDrawer.classList.remove('expanded');
    if (currentOpenMenuItem) {
      currentOpenMenuItem.classList.remove('active');
    }
    currentOpenMenuItem = null;
  }

  // Close button handler
  closeButtonCustom.addEventListener('click', (e) => {
    e.preventDefault();
    menuDetailsCustom.removeAttribute('open');
    menuToggleCustom.setAttribute('aria-expanded', 'false');
    if(mainBody.classList.contains('overflow-hidden-desktop')){
      mainBody.classList.remove('overflow-hidden-desktop');
    }
    hideSubdrawer();
  });

  // Toggle menu handler
  menuDetailsCustom.addEventListener('toggle', () => {
    const isOpen = menuDetailsCustom.hasAttribute('open');
    menuToggleCustom.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (!isOpen) hideSubdrawer();
  });

  // Show submenu in subdrawer
  function showSubmenuInSubdrawer(submenuItems, clickedItem) {
    subdrawerUl.innerHTML = '';
    const isShop = clickedItem.textContent.toUpperCase().trim() === 'WOMEN';
    subdrawerUl.classList.toggle('shop-submenu', isShop);

    submenuItems.forEach((item) => {
      const li = document.createElement('li');
      const anc = document.createElement('a');

      anc.textContent = item.title || 'Untitled';
      anc.href = item.url || '#';
      anc.classList.add('menu-drawer__menu-item', 'link--text');
      
      // Add sale-item class if text contains "SALE"
      if (item.title && item.title.includes('Black Friday')) {
        anc.classList.add('sale-item');
      }else if(item.title && item.title.includes('Archive Sale')){
        anc.classList.add('sale-item');
      }else if(item.title && item.title.includes('Sale')){
        anc.classList.add('sale-item');
      }

      li.classList.add('list-menu');
      li.appendChild(anc);
      subdrawerUl.appendChild(li);
    });

    showSubdrawer();
    currentOpenMenuItem = clickedItem;
    
    const imageUrl = clickedItem.getAttribute('data-image');
    const imageLink = clickedItem.getAttribute('data-image-link');
    if (imageUrl && drawerImage) {
      drawerImage.src = imageUrl;
      drawerImage.style.display = "block";
    }else{
      drawerImage.style.display = "none";
    }
    if(imageLink && drawerImageLink){
      drawerImageLink.href = imageLink;
    }else{
      drawerImageLink.style.pointerEvents = 'none';
    }
  }

  // Delegated event listener for menu items
  document.querySelector('.menu-drawer__navigation').addEventListener('click', function(e) {
    const menuItem = e.target.closest('.menu-drawer__menu-item');
    if (!menuItem) return;
    
    const hasChildren = menuItem.hasAttribute('data-submenu');
    
    if (hasChildren) {
      e.preventDefault();
      e.stopPropagation();
      
      // Close currency drawer if open
      if (currencyDrawer.classList.contains('open')) {
        currencyDrawer.classList.remove('open');
      }
      
      document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
        item.classList.remove('active');
      });

      if (currentOpenMenuItem === menuItem) {
        hideSubdrawer();
        return;
      }

      menuItem.classList.add('active');
      const submenuData = menuItem.getAttribute('data-submenu');
      
      try {
        const submenuItems = submenuData ? JSON.parse(submenuData) : [];
        showSubmenuInSubdrawer(submenuItems, menuItem);
      } catch (error) {
        console.error('Error parsing submenu data:', error);
      }
    }
  });

  // Close subdrawer when clicking outside
  document.addEventListener('click', function(e) {
    const isInsideMenu = menuDrawer.contains(e.target) || headerSubdrawer.contains(e.target);
    const isLocalization = e.target.closest('.desktop-localization-wrapper') !== null;
    const isCurrencyDrawer = e.target.closest('#drawer') !== null;
    
    if (!isInsideMenu && !isLocalization && !isCurrencyDrawer) {
      hideSubdrawer();
    }
  });

  // Currency drawer functionality
  document.addEventListener('click', function(e) {
    // Check if click is on the open button
    if (e.target.closest('#openDrawerBtn') || e.target.closest('#openDrawerBtnFooter')) {
      // Close subdrawer if it's open
      if (headerSubdrawer.classList.contains('active')) {
        hideSubdrawer();
      }
      
      // Open currency drawer
      currencyDrawer.classList.add('open');
        return; // Exit early since we handled this click
    }
    
    // Check if click is outside both the drawer and the open button
    if (!e.target.closest('#currencyDrawer') && !e.target.closest('#openDrawerBtn') && !e.target.closest('#openDrawerBtnFooter')) {
        currencyDrawer.classList.remove('open');
    }
  });

  closeDrawerBtn.addEventListener('click', function() {
    currencyDrawer.classList.remove('open');
  });
});